/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccPatientAddress
 */
export interface PccPatientAddress {
    /**
     * 
     * @type {string}
     * @memberof PccPatientAddress
     */
    address_line1?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPatientAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPatientAddress
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPatientAddress
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPatientAddress
     */
    country?: string;
}

/**
 * Check if a given object implements the PccPatientAddress interface.
 */
export function instanceOfPccPatientAddress(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PccPatientAddressFromJSON(json: any): PccPatientAddress {
    return PccPatientAddressFromJSONTyped(json, false);
}

export function PccPatientAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address_line1': !exists(json, 'address_line1') ? undefined : json['address_line1'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'country': !exists(json, 'country') ? undefined : json['country'],
    };
}

export function PccPatientAddressToJSON(value?: PccPatientAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address_line1': value.address_line1,
        'city': value.city,
        'state': value.state,
        'zip': value.zip,
        'country': value.country,
    };
}

